/** components/Button.tsx */
import { MouseEvent, AnchorHTMLAttributes, forwardRef } from 'react'
import { css, Interpolation, Theme } from '@emotion/react'
import { Link, LinkProps } from 'react-router-dom'

const baseStyle = (t: Theme) => css`
  display: block;
  padding: ${t.s.xxxs}px ${t.s.xxs}px;
  transition: ease-out background-color 0.3s, border-color 1s, outline 0.1s;
`

export type Props = LinkProps & {
  onClick?: (e: MouseEvent<HTMLAnchorElement>) => void
  addStyle?: Interpolation<Theme>
} & AnchorHTMLAttributes<HTMLAnchorElement>

export const LinkButton = forwardRef<HTMLAnchorElement, Props>(
  ({ to, children, addStyle, ...attr }: Props, forwardedRef) => {
    return (
      <Link to={to} {...attr} css={[baseStyle, addStyle]} ref={forwardedRef}>
        {children}
      </Link>
    )
  },
)
LinkButton.displayName = 'LinkButton'
